import { useEffect, useState } from "react";
import { useApiContext } from 'context/ApiContext';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Overview page components
import Create from "layouts/mainAdministration/pages/components/Parks/Create";
import Header from "layouts/mainAdministration/pages/components/Parks/Header";
import Modify from "layouts/mainAdministration/pages/components/Parks/Modify";
import Visualize from "layouts/mainAdministration/pages/components/Parks/Visualize";

function ParkForm() {
    const { parkFormInfosAdm, APIRequestType, getAPI } = useApiContext();

    const [selectedPark, setSelectedPark] = useState(null);
    const [formType, setFormType] = useState(null);

    useEffect(() => {
        if (parkFormInfosAdm) {
            setSelectedPark(parkFormInfosAdm.selectedPark);
            setFormType(parkFormInfosAdm.formType);
        }
    }, [parkFormInfosAdm]);

    return (
        <MDBox>
            {formType === "CreatePark" ? (
                <>
                    <Header>
                        <Create />
                    </Header>
                </>
            ) : formType === "ModifyPark" ? (
                <>
                    <Header park={selectedPark}>
                        <Modify park={selectedPark} page="MainAdministration" />
                    </Header>
                </>
            ) : formType === "VisualizePark" && (
                <>
                    <Header park={selectedPark}>
                        <Visualize park={selectedPark} />
                    </Header>
                </>
            )}
        </MDBox >
    );
}

export default ParkForm;